<div class="container row">

  <app-config-line
    [title]="'Preferencias de alertas'"
    [titleLevel]="7"
    [withHr]="false"
    [sectionReturn]="configSections.VIEWS_PREFERENCES"
    [render]="!filterOptionsBy"
  >
  </app-config-line>

  <app-config-line
    [title]="'Mostrar control de cambio de vista'"
    [description]="'Configura si deseas mostrar el botón que permite alternar entre la vista de tabla y la vista de tarjetas en el módulo de alertas.'"
    [titleLevel]="9"
    [filterBy]="filterOptionsBy"
  >
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="alertService.alertConfig.controls.views"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Vista predeterminada'"
    [description]="'Selecciona cómo deseas visualizar las alertas al iniciar: en formato de tabla o en tarjetas.'"
    [filterBy]="filterOptionsBy"
  >
    <p-dropdown 
      [options]="options" 
      [(ngModel)]="alertService.alertConfig.viewMode"
      [appendTo]="'body'" 
      [placeholder]="'Selecciona vista'" 
      optionLabel="label" 
      optionValue="value"
      [style]="{'width':'200px'}">
    </p-dropdown>
  </app-config-line>

  <app-config-line
    [title]="'Columnas visibles en la tabla'"
    [description]="'Selecciona qué columnas deseas mostrar u ocultar en la tabla de alertas, para personalizar la visualización de la información según tus necesidades.'"
    [render]="alertService.alertConfig.viewMode === 'table'"
    [filterBy]="filterOptionsBy"
  >
    <p-multiSelect
      [options]="columnOptions"
      [(ngModel)]="selectedColumns"
      defaultLabel="Seleccionar columnas"
      [showToggleAll]="false"
      [appendTo]="'body'"
      [selectedItemsLabel]="'{0} columnas seleccionadas'"
      (onChange)="updateVisibleColumns()"
      [maxSelectedLabels]="2"
    ></p-multiSelect>
  </app-config-line>




  <app-config-line
    [title]="'Información visible en las tarjetas'"
    [description]="'Selecciona qué datos se mostrarán en cada tarjeta del panel de alertas.'"
    [render]="alertService.alertConfig.viewMode === 'cards'"
    [filterBy]="filterOptionsBy"
  >
    <p-multiSelect
      [options]="cardItemOptions"
      [(ngModel)]="selectedItems"
      defaultLabel="Seleccionar elementos"
      [showToggleAll]="false"
      [appendTo]="'body'"
      [selectedItemsLabel]="'{0} elementos seleccionados'"
      (onChange)="updateVisibleCardItems()"
      [maxSelectedLabels]="2"
    ></p-multiSelect>
  </app-config-line>

  <app-config-line
    [title]="'Expandir alertas automáticamente'"
    [description]="'Muestra las alertas abiertas y desplegadas al cargar la vista (solo disponible en vista de tarjetas).' "
    [render]="alertService.alertConfig.viewMode === 'cards'"
    [filterBy]="filterOptionsBy"
  >
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="alertService.alertConfig.showExpanded"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Mostrar control de creación de alertas'"
    [description]="'Permite mostrar o ocultar el botón para crear nuevas alertas.'"
    [titleLevel]="9"
    [filterBy]="filterOptionsBy"
  >
    <!-- Switch -->
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="alertService.alertConfig.controls.create"
        (change)="toggleCreateAlert($event.target.checked)"
      />
      <span class="slider"></span>
    </label>
  
  </app-config-line>

  <ng-container *ngIf="alertService.alertsPermission$ | async as permissions">

    <!-- GPS -->
    <app-config-line
      [title]="'Crear alertas de GPS'"
      [render]="permissions.includes('gps')"
      [withHr]="false"
      [disabled]="!alertService.alertConfig.controls.create"
      [filterBy]="filterOptionsBy"
    >
      <div class="form-check">
        <input
          class="form-check-input custom-checkbox"
          type="checkbox"
          [(ngModel)]="alertService.alertConfig.create.gps"
        >
      </div>
    </app-config-line>

    <!-- Plataforma -->
    <app-config-line
      [title]="'Crear alertas de Plataforma'"
      [render]="permissions.includes('platform')"
      [withHr]="false"
      [disabled]="!alertService.alertConfig.controls.create"
      [filterBy]="filterOptionsBy"
    >
      <div class="form-check">
        <input
          class="form-check-input custom-checkbox"
          type="checkbox"
          [(ngModel)]="alertService.alertConfig.create.platform"
        >
      </div>
    </app-config-line>

    <!-- Seguridad del vehículo -->
    <app-config-line
      [title]="'Crear alertas de Seguridad del vehículo'"
      [render]="permissions.includes('security')"
      [withHr]="false"
      [disabled]="!alertService.alertConfig.controls.create"
      [filterBy]="filterOptionsBy"
    >
      <div class="form-check">
        <input
          class="form-check-input custom-checkbox"
          type="checkbox"
          [(ngModel)]="alertService.alertConfig.create.security"
        >
      </div>
    </app-config-line>

    <!-- Soluciones móviles -->
    <app-config-line
      [title]="'Crear alertas de Soluciones móviles'"
      [render]="permissions.includes('mobile')"
      [withHr]="false"
      [disabled]="!alertService.alertConfig.controls.create"
      [filterBy]="filterOptionsBy"
    >
      <div class="form-check">
        <input
          class="form-check-input custom-checkbox"
          type="checkbox"
          [(ngModel)]="alertService.alertConfig.create.mobile"
        >
      </div>
    </app-config-line>

    <!-- Fatiga 360 -->
    <app-config-line
      [title]="'Crear alertas de Fatiga 360'"
      [render]="permissions.includes('360')"
      [withHr]="false"
      [filterBy]="filterOptionsBy"
      [disabled]="!alertService.alertConfig.controls.create"
    >
      <div class="form-check">
        <input
          class="form-check-input custom-checkbox"
          type="checkbox"
          [(ngModel)]="alertService.alertConfig.create.fatigue360"
        >
      </div>
    </app-config-line>

  </ng-container>
</div>
